module.exports = __webpack_public_path__ + "static/media/partnerAdvantage3.b5620420.svg";